import addressIcon from '@/assets/icons/card/address.jpg';
import appLinkIcon from '@/assets/icons/card/app_link.jpg';
import appleIcon from '@/assets/icons/card/apple_music.jpg';
import calIcon from '@/assets/icons/card/cal.jpg';
import calendlyIcon from '@/assets/icons/card/calendly.jpg';
import callIcon from '@/assets/icons/card/call.jpg';
import discordIcon from '@/assets/icons/card/discord.jpg';
import facebookIcon from '@/assets/icons/card/facebook.png';
import facetimeIcon from '@/assets/icons/card/facetime.jpg';
import reviewsIcon from '@/assets/icons/card/google_reviews.jpg';
import instagramIcon from '@/assets/icons/card/instagram.jpg';
import linkedinIcon from '@/assets/icons/card/linkedin.jpg';
import mailIcon from '@/assets/icons/card/mail.jpg';
import messageIcon from '@/assets/icons/card/message.jpg';
import msBookingIcon from '@/assets/icons/card/microsoft.jpeg';
import openSeaIcon from '@/assets/icons/card/opensea.jpg';
import paypalIcon from '@/assets/icons/card/paypal.jpg';
import pinterestIcon from '@/assets/icons/card/pinterest.jpg';
import safariIcon from '@/assets/icons/card/safari.jpg';
import salonkeeIcon from '@/assets/icons/card/salonkee.jpg';
import snapchatIcon from '@/assets/icons/card/snapchat.jpg';
import soundcloudIcon from '@/assets/icons/card/soundcloud.jpg';
import spotifyIcon from '@/assets/icons/card/spotify.jpg';
import telegramIcon from '@/assets/icons/card/telegram.jpg';
import threadsIcon from '@/assets/icons/card/threads.jpg';
import tiktokIcon from '@/assets/icons/card/tiktok.jpg';
import twitchIcon from '@/assets/icons/card/twitch.jpg';
import whatsappIcon from '@/assets/icons/card/whatsapp.jpg';
import xIcon from '@/assets/icons/card/x.jpg';
import youtubeIcon from '@/assets/icons/card/youtube.jpg';
import zohoIcon from '@/assets/icons/card/zoho.jpg';

const iconMap = {
  address: addressIcon,
  app_link: appLinkIcon,
  apple_music: appleIcon,
  cal: calIcon,
  calendly: calendlyIcon,
  call: callIcon,
  discord: discordIcon,
  google_reviews: reviewsIcon,
  instagram: instagramIcon,
  linkedin: linkedinIcon,
  mail: mailIcon,
  message: messageIcon,
  opensea: openSeaIcon,
  paypal: paypalIcon,
  pinterest: pinterestIcon,
  safari: safariIcon,
  snapchat: snapchatIcon,
  soundcloud: soundcloudIcon,
  spotify: spotifyIcon,
  telegram: telegramIcon,
  threads: threadsIcon,
  tiktok: tiktokIcon,
  twitch: twitchIcon,
  whatsapp: whatsappIcon,
  x: xIcon,
  youtube: youtubeIcon,
  zoho: zohoIcon,
  facebook: facebookIcon,
  facetime: facetimeIcon,
  ms_booking: msBookingIcon,
  salonkee: salonkeeIcon,
};

/**
 * Returns the appropriate icon for a given link type
 * @param iconType The type of the link (e.g., 'mail', 'call', 'whatsapp')
 * @returns The URL of the icon image
 */
export const getIconForLink = (iconType: string | null | undefined): string => {
  const type = iconType?.toLowerCase() || '';
  return iconMap[type as keyof typeof iconMap] || safariIcon;
};
